import { Link } from 'react-router-dom';
import { timelineFeed } from '@/mocks/timeline';
import SectionHeading from '@/components/feature/SectionHeading';

const TAG_STYLE: Record<string, string> = {
  反转: 'bg-accent-500 text-accent-950',
  回应: 'bg-secondary-500 text-background-50',
  发酵: 'bg-primary-500 text-background-50',
  存疑: 'bg-accent-100 text-accent-900',
  归档: 'bg-background-300 text-foreground-700',
};

export default function TimelinePreview() {
  const items = timelineFeed.slice(0, 6);

  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-content px-4 md:px-6 py-14 md:py-20">
        <SectionHeading
          eyebrow="事件时间线"
          title="事情到底是怎么一步一步走到今天的"
          desc="把散落在各个平台的爆料、回应和反转按时间排好，先看顺序，再下判断。"
          action={
            <Link
              to="/timeline"
              className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              完整时间线
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />

        <ol className="relative border-l-2 border-background-300 pl-6 md:pl-8">
          {items.map((item) => (
            <li key={`${item.date}-${item.time}-${item.slug}`} className="relative pb-8 last:pb-0">
              <span className="absolute -left-[31px] top-1.5 h-3.5 w-3.5 rounded-full border-2 border-background-100 bg-primary-500 md:-left-[39px]"></span>
              <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                <div className="flex flex-wrap items-center gap-3">
                  <span className="font-heading text-sm font-bold text-foreground-950">
                    {item.date} {item.time}
                  </span>
                  <span
                    className={`rounded-full px-2.5 py-0.5 text-[11px] font-medium ${
                      TAG_STYLE[item.tag] || 'bg-background-200 text-foreground-700'
                    }`}
                  >
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{item.categoryName}</span>
                </div>
                <h3 className="mt-3 text-sm font-medium text-foreground-900 md:text-base">
                  <Link to={`/article/${item.slug}`} className="hover:text-primary-600 transition-colors">
                    {item.title}
                  </Link>
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}